/**
 * Cleanest way to html entities decode
 * @param input
 * @returns {string}
 */
export function htmlDecode(input) {
  if (typeof window !== `undefined`) {
    const doc = new DOMParser().parseFromString(input, 'text/html')
    return doc.documentElement.textContent
  }
  return input
}

/**
 * Truncate strings
 * @param str = string to truncate
 * @param n = number of characters to truncate to
 * @param symbol = symbol to use when truncated — default is "..."
 * @returns {string}
 */
export const truncate = (str, n, symbol = ' ...') => {
  return str.length > n ? str.substr(0, n - 1) + ` ${symbol}` : str
}

/**
 * Create array of pagination items
 * @param {int} currentPage
 * @param {int} nrOfPages
 * @returns {Array}
 */
export function pagination(currentPage, nrOfPages) {
  let delta = 2
  let range = []
  let rangeWithDots = []
  let l

  range.push(1)

  if (nrOfPages <= 1) {
    return range
  }

  for (let i = currentPage - delta; i <= currentPage + delta; i++) {
    if (i < nrOfPages && i > 1) {
      range.push(i)
    }
  }
  range.push(nrOfPages)

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1)
      } else if (i - l !== 1) {
        rangeWithDots.push('...')
      }
    }
    rangeWithDots.push(i)
    l = i
  }

  return rangeWithDots
}

/**
 * Check for empty items in object
 * @param obj = object to check
 * @returns {boolean}
 */
export const checkForEmptyProperties = obj => {
  for (var key in obj) {
    if (obj[key] === null || obj[key] === '') return false
  }
  return true
}

/**
 * Lowercase string, replace spaces with dashes
 * @param str = object to check
 * @returns {str}
 */
export const lowercaseNoSpaces = str => {
  return str.replace(/\s+/g, '-').toLowerCase()
}

// Check for photo url, if none exists
// Use API and pass in their names for placeholders
// And a random color from brand palette
export const getImgUrl = data => {
  const fields = data.fields || {}

  if (fields.candidate_photo) {
    return fields.candidate_photo.url
  }

  if (fields.gapi_photo_url) {
    return fields.gapi_photo_url
  }

  if (fields.vsapi_photo) {
    return fields.vsapi_photo
  }

  const [fName, lName] = getNamePair(data)

  const colors = ['ff5447', '2bdada', 'FFE928']
  let color = Math.floor(Math.random() * Math.floor(colors.length))

  return `https://ui-avatars.com/api/?background=${colors[color]}&color=1c1c1c&format=svg&name=${fName}+${lName}`
}

export const imgUrlOrDefault = (url, name = 'N N') => {
  if (url) {
    return url
  }

  const names = name.split(' ')
  const fName = names[0]
  const lName = names[names.length - 1]

  const colors = ['ff5447', '2bdada', 'FFE928']
  const color = Math.floor(Math.random() * Math.floor(colors.length))

  return `https://ui-avatars.com/api/?background=${colors[color]}&color=1c1c1c&format=svg&name=${fName}+${lName}`
}

export const getNamePair = data => {
  const fields = data.fields || {}
  const post = data.post || {}
  const gapi = data.gapi || {}

  let name =
    (fields.gapi_name && fields.gapi_name.split(' ')) ||
    (post.post_title && post.post_title.split(' ')) ||
    (gapi.official && gapi.official.name && gapi.official.name.split(' '))
  let fName = fields.vsapi_first_name
  let lName = fields.vsapi_last_name

  if (name && name.length > 1) {
    fName = name[0]
    lName = name[name.length - 1]
  }

  return [fName, lName]
}

export const getPollingLocationHours = hours => {
  if (!hours) {
    return 'No Data'
  }

  if (!hours.match(/(Oct|Nov)/)) {
    return hours
  }

  const currentDay = new Date()
  const currentDayOfMonth = currentDay.getDate()
  const currentMonth = currentDay.getMonth()

  const lines = hours.split(/\r?\n/)

  let l = 'Closed'
  lines.forEach(line => {
    const [weekdayMonthDay, times] = line.split(': ')

    const monthMatches = weekdayMonthDay.match(/(Oct|Nov)/)
    const dayMatches = weekdayMonthDay.match(/(\d+)/)

    const month = monthMatches && monthMatches[1] === 'Oct' ? 9 : 10
    const day = dayMatches && dayMatches[1] && parseInt(dayMatches[1])

    if (month === currentMonth && day === currentDayOfMonth) {
      l = times
    }
  })

  return l
}
